import { Component, effect } from '@angular/core';
import { AppService } from './shared/services/app.service';
import { ToastService, Toast } from './shared/services/toast.service';

@Component({
  standalone: false,
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  title = 'alt-pay-ui';
  isSpinner: boolean = false;
  toasts: Toast[] = [];

  constructor(private _app: AppService,
    private _toast: ToastService
  ) {
    effect(() => {
      const vm = this;
      vm.isSpinner = vm._app.spinnerData;
    });
    this.toasts = this._toast.toasts;
  }
}
